import { Box, Group, Paper, Stack, Text, Title } from "@mantine/core";
import type React from "react";
import type { QuestionType, SurveyDefinition } from "@/utils/survey";

export interface SurveyDefinitionViewerProps {
  definition: SurveyDefinition;
}

export const SurveyDefinitionViewer: React.FC<SurveyDefinitionViewerProps> = ({
  definition,
}) => {
  const renderQuestionType = (type: QuestionType, options?: string[]) => {
    switch (type) {
      case "YES_NO":
        return (
          <Text size="sm" c="dimmed">
            Yes/No answer
          </Text>
        );

      case "SHORT_TEXT":
        return (
          <Text size="sm" c="dimmed">
            Short text answer
          </Text>
        );

      case "LONG_TEXT":
        return (
          <Text size="sm" c="dimmed">
            Long text answer
          </Text>
        );

      case "MULTIPLE_CHOICE":
        return (
          <Stack gap="xs">
            <Text size="sm" c="dimmed">
              Multiple choice (select one):
            </Text>
            {options?.map((option, index) => (
              <Text key={index} size="sm">
                • {option}
              </Text>
            ))}
          </Stack>
        );

      case "MULTIPLE_CHOICE_MULTI":
        return (
          <Stack gap="xs">
            <Text size="sm" c="dimmed">
              Multiple choice (select multiple):
            </Text>
            {options?.map((option, index) => (
              <Text key={index} size="sm">
                • {option}
              </Text>
            ))}
          </Stack>
        );

      default:
        return <Text c="red">Unsupported question type</Text>;
    }
  };

  return (
    <Stack>
      <Title order={5}>Survey Questions</Title>
      {definition.questions.map((question) => (
        <Paper key={question.id} withBorder p="md" radius="md">
          <Stack>
            <Group>
              <Text fw={500}>
                {question.label}
                {question.required && (
                  <Text span color="red">
                    {" "}
                    *
                  </Text>
                )}
              </Text>
            </Group>

            {question.description && (
              <Text size="sm" c="dimmed">
                {question.description}
              </Text>
            )}

            <Box mt={5}>
              {renderQuestionType(question.type, question.options ?? [])}
            </Box>
          </Stack>
        </Paper>
      ))}

      <Text size="sm" c="dimmed">
        Survey Version Date: {new Date(definition.version).toLocaleString()}
      </Text>
    </Stack>
  );
};
